import { render, staticRenderFns } from "./InstitutionalShareholding.vue?vue&type=template&id=14eae768&scoped=true"
import script from "./InstitutionalShareholding.vue?vue&type=script&lang=js"
export * from "./InstitutionalShareholding.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalShareholding.vue?vue&type=style&index=0&id=14eae768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eae768",
  null
  
)

export default component.exports